import { IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { MoreVert } from '@mui/icons-material';
import { ReactComponent as TransactionDetailChevronIcon } from '../../../assets/icons/transaction-detail-chevron.svg';

const useStyles = makeStyles(() => ({
  root: {
    padding: 8,
    '@media (max-width:768px)': {
      padding: 5,
    },
  },
  detailButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:hover $detailIcon circle': {
      fill: '#e8e8e8',
    },
  },
  detailIcon: {
    width: 32,
    height: 32,
    display: 'block',
    '& circle': {
      fill: '#ffffff',
      transition: 'fill 0.2s ease',
    },
  },
}));

export interface ButtonMoreProps {
  id?: string;
  variant?: 'menu' | 'detail';
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const ButtonMore = ({ id, onClick, variant = 'menu' }: ButtonMoreProps) => {
  const classes = useStyles();
  const isDetail = variant === 'detail';

  return (
    <IconButton
      id={id}
      classes={{ root: `${classes.root}${isDetail ? ` ${classes.detailButton}` : ''}` }}
      onClick={e => onClick && onClick(e)}
    >
      {isDetail ? (
        <TransactionDetailChevronIcon className={classes.detailIcon} aria-hidden />
      ) : (
        <MoreVert fontSize="small" />
      )}
    </IconButton>
  );
};

export default ButtonMore;
